import { Volume2 } from "lucide-react";
import MessageContainer from "./MessageContainer";
import MessageFooter from "./MessageFooter";

export default function AudioMessage({ message }) {
  const { content, direction, status, createdAt } = message;
  const isOutbound = direction === "OUTBOUND";
  const audioUrl = content.media?.link;

  if (!audioUrl) {
    return null;
  }

  return (
    <MessageContainer isOutbound={isOutbound}>
      <div className="flex items-center gap-3 py-2 px-2">
        <Volume2 className="h-5 w-5 text-gray-600 dark:text-slate-300 flex-shrink-0" />
        <audio
          controls
          className="w-40 h-6"
          controlsList="nodownload"
        >
          <source src={audioUrl} type="audio/ogg" />
          <source src={audioUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>
      <MessageFooter status={status} timestamp={createdAt} isOutbound={isOutbound} />
    </MessageContainer>
  );
}
